import React, { useState, useEffect } from "react";
import XoaTatToanHopDong from "../XoaTatToan/XoaTatToanHopDong";
import ThongBaoChucNang from "./ThongBaoChucNang";
import TatToanChoDuyetApi from "service/tatToanChoDuyetApi";
export const BtnXoaTatToan = ({ item , SearchDanhSach}) => {
    const initThucHien = {
        duocphep: false,
        thongbao: '',
    };
    const [thuhien, setThucHien] = useState(initThucHien);
    const [isModalVisible, setModalVisible] = useState(false);
    const setModalXoaTatToanShow = () => {
        CheckThucHien();
    }

    const CheckThucHien = () => {
        TatToanChoDuyetApi.phanQuyenTatToanChoDuyetTheoChucNang("", 3, item.TatToanChoDuyetID).then((response) => {
            setThucHien({
                ...thuhien,
                duocphep: response.data.ThucHien,
                thongbao: response.data.Message,
            });
            setModalVisible(!isModalVisible);
        });
    }

    return (
        <>
            <a onClick={setModalXoaTatToanShow} href={() => false} className="blue btn-link" title="Xóa tất toán">
                <img src="/app-assets/images/icon-xoa-v2.png" style={{marginBottom:"3px"}} />
            </a>
            {isModalVisible && thuhien.duocphep && (
                <XoaTatToanHopDong
                    show={isModalVisible}
                    onHide={setModalXoaTatToanShow}
                    item={item}
                    SearchDanhSach= {SearchDanhSach}
                ></XoaTatToanHopDong>
            )}
            {isModalVisible && !thuhien.duocphep && (
                <ThongBaoChucNang
                    show={isModalVisible}
                    onHide={setModalXoaTatToanShow}
                    item={thuhien}
                ></ThongBaoChucNang>
            )}
        </>
    );
};
